import React, { useEffect } from 'react'
import Header from '../headerone/Main'
import Blog from '../menhome/Blog'
import Client from '../menhome/Client'
import Offer from '../menhometwo/Offer'
import Counter from '../menhome/Counter'
import Event from '../menhome/Event'
import Intro from '../menhome/Intro'
import Mayor from '../menhome/Mayor'
import Newlast from '../menhome/Newlast'
import Portfolio from '../menhome/Portfolio'
import Service from '../menhome/Service'
import Slider from '../menhome/Slider'
import Testimonial from '../menhome/Testimonial'
import Cta from '../menhometwo/Cta'

function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Home || State of GTS";
  }, [])

  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
            <Slider/>
            {/* <Blog/> */}
            {/* <Offer/> */}
            {/* <Intro/> */}
            {/* <Service/> */}
            {/* <Counter/> */}
            {/* <Mayor/> */}
            {/* <Cta/> */}
            {/* <Portfolio/> */}
            <Client/>
            {/* <Counter/> */}
            {/* <Testimonial/> */}
            {/* <Event/> */}
            {/* <Newlast/> */}
        </div>

    </>
  )
}

export default Main